import { MessageDispatchesScreen } from "./message-dispatches.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";
import { MessageDispatchEditRoutes } from "../message-dispatch-edit";

export const MessagesRoutes: RouteDefinition[] = [
	{
		path: Paths.messagesDispatches.path,
		element: <MessageDispatchesScreen />,
		requiredPermissions: ["UserInAccountPermission_MessageDispatchAdmin_Read"],
	},
	...MessageDispatchEditRoutes,
];
